var _defs, _g, _g2, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "325.805 103.202 173.06 194.785",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-1",
    d: "M166.21 132.77s-16-78.68 54.8-94.55c72.75-16.31 95.07 32.05 96.28 58.39s-22.07 27.57-18.46 62.88-79.72 22.42-105.08 7.31c-26.45-15.8-27.54-34.03-27.54-34.03z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube-icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-1",
    d: "M305.54 147.24c-8.91 3.14-18.68 3.71-27.22 7.78-15.17 7.21-24.18 24.36-39.93 30.24-14.53 5.42-32.6-1.56-39.72-15.35-4.43-8.59-4.86-18.88-9.69-27.23-6.88-11.89-21.21-17.55-29.24-28.69-8.27-11.49-8.17-28.32.21-39.7s25.47-18.75 37.88-12c28.08 15.4 27.56 5.64 43.9-17.42 29.36-41.45 76-16.45 64.16 28.15-1.51 5.71-4.09 11.31-4 17.22.37 14.58 20.89 22.5 21.15 37.09.23 9.49-8.58 16.78-17.5 19.91z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "youtube-icon_svg__cls-4",
    style: {
      mixBlendMode: "multiply"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "youtube-icon_svg__cls-5",
    clipPath: "url(#youtube-icon_svg__a)",
    transform: "translate(175.595 103.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-6",
    fill: "#962432",
    d: "M150.21 194.21l6.81.58h-6.81v-.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-7",
    fill: "#972432",
    d: "M150.21 193.31l17.4 1.48h-10.59l-6.81-.58v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-8",
    fill: "#982432",
    d: "M150.21 192.4l28 2.39h-10.6l-17.4-1.48v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-9",
    fill: "#992432",
    d: "M150.21 191.49l38.59 3.3h-10.59l-28-2.39v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-10",
    fill: "#9a2432",
    d: "M150.21 190.58l49.19 4.21h-10.6l-38.59-3.3v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-11",
    fill: "#9b2432",
    d: "M150.21 189.68l59.78 5.11H199.4l-49.19-4.21v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-12",
    fill: "#9c2432",
    d: "M150.21 188.77l70.38 6.02h-10.6l-59.78-5.11v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-13",
    fill: "#9d2432",
    d: "M150.21 187.86l80.97 6.93h-10.59l-70.38-6.02v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-14",
    fill: "#9e2432",
    d: "M150.21 186.96l91.56 7.83h-10.59l-80.97-6.93v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-15",
    fill: "#9f2431",
    d: "M150.21 186.05l102.16 8.74h-10.6l-91.56-7.83v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-16",
    fill: "#a02431",
    d: "M150.21 185.14l112.75 9.65h-10.59l-102.16-8.74v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-17",
    fill: "#a12431",
    d: "M150.21 184.23l123.35 10.56h-10.6l-112.75-9.65v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-18",
    fill: "#a22431",
    d: "M150.21 183.33l133.94 11.46h-10.59l-123.35-10.56v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-19",
    fill: "#a32431",
    d: "M150.21 182.42l144.54 12.37h-10.6l-133.94-11.46v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-20",
    fill: "#a42431",
    d: "M150.21 181.51l155.13 13.28h-10.59l-144.54-12.37v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-21",
    fill: "#a52431",
    d: "M150.21 180.6l165.72 14.19h-10.59l-155.13-13.28v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-22",
    fill: "#a62431",
    d: "M150.21 179.7l165.8 14.19-.08.9-165.72-14.19v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-23",
    fill: "#a72531",
    d: "M150.21 178.79l165.87 14.2-.07.9-165.8-14.19v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-24",
    fill: "#a82531",
    d: "M150.21 177.88l165.95 14.21-.08.9-165.87-14.2v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-25",
    fill: "#a92530",
    d: "M150.21 176.98l166.03 14.21-.08.9-165.95-14.21v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-26",
    fill: "#aa2530",
    d: "M150.21 176.07l166.11 14.22-.08.9-166.03-14.21v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-27",
    fill: "#ab2530",
    d: "M150.21 175.16l166.18 14.23-.07.9-166.11-14.22v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-28",
    fill: "#ac2530",
    d: "M150.21 174.25l166.26 14.24-.08.9-166.18-14.23v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-29",
    fill: "#ad2530",
    d: "M150.21 173.35l166.34 14.24-.08.9-166.26-14.24v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-30",
    fill: "#ae2530",
    d: "M150.21 172.44l166.41 14.25-.07.9-166.34-14.24v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-31",
    fill: "#af2530",
    d: "M150.21 171.53l166.49 14.26-.08.9-166.41-14.25v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-32",
    fill: "#b02530",
    d: "M150.21 170.63l166.57 14.26-.08.9-166.49-14.26v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-33",
    fill: "#b12530",
    d: "M150.21 169.72l166.65 14.27-.08.9-166.57-14.26v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-34",
    fill: "#b22530",
    d: "M150.21 168.81l166.72 14.28-.07.9-166.65-14.27v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-35",
    fill: "#b4252f",
    d: "M150.21 167.91l166.8 14.28-.08.9-166.72-14.28v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-36",
    fill: "#b5252f",
    d: "M150.21 167l166.88 14.29-.08.9-166.8-14.28V167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-37",
    fill: "#b6252f",
    d: "M150.21 166.09l166.95 14.3-.07.9L150.21 167v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-38",
    fill: "#b7252f",
    d: "M150.21 165.18l167.03 14.31-.08.9-166.95-14.3v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-39",
    fill: "#b8252f",
    d: "M150.21 164.28l167.11 14.3-.08.91-167.03-14.31v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-40",
    fill: "#b9252f",
    d: "M150.21 163.37l167.18 14.31-.07.9-167.11-14.3v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-41",
    fill: "#ba252f",
    d: "M150.21 162.46l167.26 14.32-.08.9-167.18-14.31v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-42",
    fill: "#bb252f",
    d: "M150.21 161.56l167.34 14.32-.08.9-167.26-14.32v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-43",
    fill: "#bc252f",
    d: "M150.21 160.65l167.42 14.33-.08.9-167.34-14.32v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-44",
    fill: "#bd252f",
    d: "M150.21 159.74l167.49 14.34-.07.9-167.42-14.33v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-45",
    fill: "#be252e",
    d: "M150.21 158.83l167.57 14.35-.08.9-167.49-14.34v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-46",
    fill: "#bf252e",
    d: "M150.21 157.93l167.65 14.35-.08.9-167.57-14.35v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-47",
    fill: "#c0262e",
    d: "M150.21 157.02l167.73 14.36-.08.9-167.65-14.35v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-48",
    fill: "#c1262e",
    d: "M150.21 156.11l167.8 14.37-.07.9-167.73-14.36v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-49",
    fill: "#c2262e",
    d: "M150.21 155.21l167.88 14.37-.08.9-167.8-14.37v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-50",
    fill: "#c3262e",
    d: "M150.21 154.3l167.96 14.38-.08.9-167.88-14.37v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-51",
    fill: "#c4262e",
    d: "M150.21 153.39l168.03 14.39-.07.9-167.96-14.38v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-52",
    fill: "#c5262e",
    d: "M150.21 152.48l168.11 14.4-.08.9-168.03-14.39v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-53",
    fill: "#c6262e",
    d: "M150.21 151.58l168.19 14.4-.08.9-168.11-14.4v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-54",
    fill: "#c7262e",
    d: "M150.21 150.67l168.27 14.41-.08.9-168.19-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-55",
    fill: "#c8262d",
    d: "M150.21 149.76l168.28 14.41v.71l-.01.2-168.27-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-56",
    fill: "#c9262d",
    d: "M150.21 148.85l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-57",
    fill: "#ca262d",
    d: "M150.21 147.95l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-58",
    fill: "#cb262d",
    d: "M150.21 147.04l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-59",
    fill: "#cc262d",
    d: "M150.21 146.13l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-60",
    fill: "#cd262d",
    d: "M150.21 145.23l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-61",
    fill: "#ce262d",
    d: "M150.21 144.32l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-62",
    fill: "#cf262d",
    d: "M150.21 143.41l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-63",
    fill: "#d0262d",
    d: "M150.21 142.5l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-64",
    fill: "#d1262d",
    d: "M150.21 141.6l168.28 14.41v.9L150.21 142.5v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-65",
    fill: "#d2262c",
    d: "M150.21 140.69l168.28 14.41v.91L150.21 141.6v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-66",
    fill: "#d3262c",
    d: "M150.21 139.78l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-67",
    fill: "#d4262c",
    d: "M150.21 138.88l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-68",
    fill: "#d5262c",
    d: "M150.21 137.97l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-69",
    fill: "#d6262c",
    d: "M150.21 137.06l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-70",
    fill: "#d7262c",
    d: "M150.21 136.16l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-71",
    fill: "#d8262c",
    d: "M150.21 135.25l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-72",
    fill: "#d9272c",
    d: "M150.21 134.34l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-73",
    fill: "#da272c",
    d: "M150.21 133.43l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-74",
    fill: "#db272c",
    d: "M150.21 132.53l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-75",
    fill: "#dc272b",
    d: "M150.21 131.62l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-76",
    fill: "#dd272b",
    d: "M150.21 130.71l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-77",
    fill: "#de272b",
    d: "M150.21 129.81l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-78",
    fill: "#df272b",
    d: "M150.21 128.9l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-79",
    fill: "#e0272b",
    d: "M150.21 127.99l168.28 14.41v.91L150.21 128.9v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-80",
    fill: "#e1272b",
    d: "M150.21 127.08l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-81",
    fill: "#e2272b",
    d: "M150.21 126.18l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-82",
    fill: "#e3272b",
    d: "M150.21 125.27l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-83",
    fill: "#e4272b",
    d: "M150.21 124.36l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-84",
    fill: "#e5272b",
    d: "M150.21 123.45l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-85",
    fill: "#e6272a",
    d: "M150.21 122.55l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-86",
    fill: "#e7272a",
    d: "M150.21 121.64l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-87",
    fill: "#e8272a",
    d: "M150.21 120.73l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-88",
    fill: "#e9272a",
    d: "M150.21 119.83l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-89",
    fill: "#ea272a",
    d: "M150.21 118.92l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-90",
    fill: "#eb272a",
    d: "M150.21 118.01l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-91",
    fill: "#ec272a",
    d: "M150.21 117.11l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-92",
    fill: "#ed272a",
    d: "M150.21 116.2l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-93",
    fill: "#ee272a",
    d: "M150.21 115.29l168.28 14.41v.91L150.21 116.2v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-94",
    fill: "#ef272a",
    d: "M150.21 114.38l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-95",
    fill: "#f02729",
    d: "M150.21 113.48l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-96",
    fill: "#f12729",
    d: "M150.21 112.57l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-97",
    fill: "#f22829",
    d: "M150.21 111.66l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-98",
    fill: "#f32829",
    d: "M150.21 110.75l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-99",
    fill: "#f42829",
    d: "M150.21 109.85l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-100",
    fill: "#f52829",
    d: "M150.21 108.94l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-101",
    fill: "#f62829",
    d: "M150.21 108.03l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-102",
    fill: "#f72829",
    d: "M150.21 107.13l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-103",
    fill: "#f82829",
    d: "M150.21 106.22l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-104",
    fill: "#f92829",
    d: "M150.21 105.31l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-105",
    fill: "#fa2828",
    d: "M150.21 104.41l168.28 14.4v.91l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-106",
    fill: "#fb2828",
    d: "M150.21 103.5l168.28 14.41v.9l-168.28-14.4v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-107",
    fill: "#fc2828",
    d: "M150.21 102.59L318.49 117v.91L150.21 103.5v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-108",
    fill: "#fd2828",
    d: "M150.21 101.68l168.28 14.41v.91l-168.28-14.41v-.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-109",
    fill: "#ff2828",
    d: "M150.21 100.78l168.28 14.41v.9l-168.28-14.41v-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-109",
    fill: "#ff2828",
    d: "M150.21 99.76l168.28 14.41v1.02l-168.28-14.41v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-110",
    fill: "#ff2928",
    d: "M150.21 98.75l168.28 14.41v1.01L150.21 99.76v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-111",
    fill: "#ff2a29",
    d: "M150.21 97.73l168.28 14.41v1.02L150.21 98.75v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-112",
    fill: "#ff2b29",
    d: "M150.21 96.72l168.28 14.41v1.01L150.21 97.73v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-113",
    fill: "#ff2c2a",
    d: "M150.21 95.71l168.28 14.4v1.02L150.21 96.72v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-114",
    fill: "#ff2d2a",
    d: "M150.21 94.69l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-115",
    fill: "#ff2e2b",
    d: "M150.21 93.68l168.28 14.41v1.01L150.21 94.69v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-116",
    fill: "#ff2f2b",
    d: "M150.21 92.66l168.28 14.41v1.02L150.21 93.68v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-117",
    fill: "#ff302b",
    d: "M150.21 91.65l168.28 14.41v1.01L150.21 92.66v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-118",
    fill: "#ff312c",
    d: "M150.21 90.64l168.28 14.4v1.02L150.21 91.65v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-119",
    fill: "#ff322c",
    d: "M150.21 89.62l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-120",
    fill: "#ff332d",
    d: "M150.21 88.61l168.28 14.41v1.01L150.21 89.62v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-121",
    fill: "#ff342d",
    d: "M150.21 87.59L318.49 102v1.02L150.21 88.61v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-122",
    fill: "#ff352d",
    d: "M150.21 86.58l168.28 14.41V102L150.21 87.59v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-123",
    fill: "#ff362e",
    d: "M150.21 85.56l168.28 14.41v1.02L150.21 86.58v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-124",
    fill: "#ff372e",
    d: "M150.21 84.55l168.28 14.41v1.01L150.21 85.56v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-125",
    fill: "#ff382f",
    d: "M150.21 83.54l168.28 14.4v1.02L150.21 84.55v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-126",
    fill: "#ff392f",
    d: "M150.21 82.52l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-127",
    fill: "#ff3a30",
    d: "M150.21 81.51l168.28 14.41v1.01L150.21 82.52v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-128",
    fill: "#ff3b30",
    d: "M150.21 80.49L318.49 94.9v1.02L150.21 81.51v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-129",
    fill: "#ff3c30",
    d: "M150.21 79.48l168.28 14.41v1.01L150.21 80.49v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-130",
    fill: "#ff3d31",
    d: "M150.21 78.47l168.28 14.4v1.02L150.21 79.48v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-131",
    fill: "#ff3e31",
    d: "M150.21 77.45l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-132",
    fill: "#ff3f32",
    d: "M150.21 76.44l168.28 14.4v1.02L150.21 77.45v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-133",
    fill: "#ff4032",
    d: "M150.21 75.42l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-134",
    fill: "#ff4132",
    d: "M150.21 74.41l168.28 14.41v1.01L150.21 75.42v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-135",
    fill: "#ff4233",
    d: "M150.21 73.39L318.49 87.8v1.02L150.21 74.41v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-136",
    fill: "#ff4333",
    d: "M150.21 72.38l168.28 14.41v1.01L150.21 73.39v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-137",
    fill: "#ff4434",
    d: "M150.21 71.37l168.28 14.4v1.02L150.21 72.38v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-138",
    fill: "#ff4534",
    d: "M150.21 70.35l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-139",
    fill: "#ff4635",
    d: "M150.21 69.34l168.28 14.41v1.01L150.21 70.35v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-140",
    fill: "#ff4735",
    d: "M150.21 68.32l168.28 14.41v1.02L150.21 69.34v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-141",
    fill: "#ff4835",
    d: "M150.21 67.31l168.28 14.41v1.01L150.21 68.32v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-142",
    fill: "#ff4936",
    d: "M150.21 66.3l168.28 14.4v1.02L150.21 67.31V66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-143",
    fill: "#ff4a36",
    d: "M150.21 65.28l168.28 14.41v1.01L150.21 66.3v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-144",
    fill: "#ff4b37",
    d: "M150.21 64.27l168.28 14.4v1.02L150.21 65.28v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-145",
    fill: "#ff4c37",
    d: "M150.21 63.25l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-146",
    fill: "#ff4d37",
    d: "M150.21 62.24l168.28 14.41v1.01L150.21 63.25v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-147",
    fill: "#ff4e38",
    d: "M150.21 61.22l168.28 14.41v1.02L150.21 62.24v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-148",
    fill: "#ff4f38",
    d: "M150.21 60.21l168.28 14.41v1.01L150.21 61.22v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-149",
    fill: "#ff5039",
    d: "M150.21 59.2l168.28 14.4v1.02L150.21 60.21V59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-150",
    fill: "#ff5139",
    d: "M150.21 58.18l168.28 14.41v1.01L150.21 59.2v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-151",
    fill: "#ff523a",
    d: "M150.21 57.17l168.28 14.41v1.01L150.21 58.18v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-152",
    fill: "#ff533a",
    d: "M150.21 56.15l168.28 14.41v1.02L150.21 57.17v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-153",
    fill: "#ff543a",
    d: "M150.21 55.14l168.28 14.41v1.01L150.21 56.15v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-154",
    fill: "#ff553b",
    d: "M150.21 54.13l168.28 14.4v1.02L150.21 55.14v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-155",
    fill: "#ff563b",
    d: "M150.21 53.11l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-156",
    fill: "#ff573c",
    d: "M150.21 52.1l168.28 14.4v1.02L150.21 53.11V52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-157",
    fill: "#ff583c",
    d: "M150.21 51.08l168.28 14.41v1.01L150.21 52.1v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-158",
    fill: "#ff593c",
    d: "M150.21 50.07l168.28 14.41v1.01L150.21 51.08v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-159",
    fill: "#ff5a3d",
    d: "M150.21 49.05l168.28 14.41v1.02L150.21 50.07v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-160",
    fill: "#ff5b3d",
    d: "M150.21 48.04l168.28 14.41v1.01L150.21 49.05v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-161",
    fill: "#ff5c3e",
    d: "M150.21 47.02l168.28 14.41v1.02L150.21 48.04v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-162",
    fill: "#ff5d3e",
    d: "M150.21 46.01l168.28 14.41v1.01L150.21 47.02v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-163",
    fill: "#ff5e3f",
    d: "M150.21 45l168.28 14.41v1.01L150.21 46.01V45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-164",
    fill: "#ff5f3f",
    d: "M150.21 43.98l168.28 14.41v1.02L150.21 45v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-165",
    fill: "#ff603f",
    d: "M150.21 42.97l168.28 14.41v1.01L150.21 43.98v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-166",
    fill: "#ff6140",
    d: "M150.21 41.95l168.28 14.41v1.02L150.21 42.97v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-167",
    fill: "#ff6340",
    d: "M150.21 40.94l168.28 14.41v1.01L150.21 41.95v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-168",
    fill: "#ff6441",
    d: "M150.21 39.93l168.28 14.4v1.02L150.21 40.94v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-169",
    fill: "#ff6541",
    d: "M150.21 38.91l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-170",
    fill: "#ff6641",
    d: "M150.21 37.9l168.28 14.41v1.01L150.21 38.91V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-171",
    fill: "#ff6742",
    d: "M150.21 36.88l168.28 14.41v1.02L150.21 37.9v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-172",
    fill: "#ff6842",
    d: "M150.21 35.87l168.28 14.41v1.01L150.21 36.88v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-173",
    fill: "#ff6943",
    d: "M150.21 34.85l168.28 14.41v1.02L150.21 35.87v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-174",
    fill: "#ff6a43",
    d: "M150.21 33.84l168.28 14.41v1.01L150.21 34.85v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-175",
    fill: "#ff6b44",
    d: "M150.21 32.83l168.28 14.4v1.02L150.21 33.84v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-176",
    fill: "#ff6c44",
    d: "M150.21 31.81l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-177",
    fill: "#ff6d44",
    d: "M150.21 30.8l168.28 14.41v1.01L150.21 31.81V30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-178",
    fill: "#ff6e45",
    d: "M150.21 29.78l168.28 14.41v1.02L150.21 30.8v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-179",
    fill: "#ff6f45",
    d: "M150.21 28.77l168.28 14.41v1.01L150.21 29.78v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-180",
    fill: "#ff7046",
    d: "M150.21 27.76l168.28 14.4v1.02L150.21 28.77v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-181",
    fill: "#ff7146",
    d: "M150.21 26.74l168.28 14.41v1.01l-168.28-14.4v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-182",
    fill: "#ff7246",
    d: "M150.21 25.73l168.28 14.41v1.01L150.21 26.74v-1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-183",
    fill: "#ff7347",
    d: "M150.21 24.71l168.28 14.41v1.02L150.21 25.73v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-184",
    fill: "#ff7447",
    d: "M150.21 23.7l168.28 14.41v1.01L150.21 24.71V23.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-185",
    fill: "#ff7548",
    d: "M150.21 22.68l168.28 14.41v1.02L150.21 23.7v-1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-186",
    fill: "#ff7648",
    d: "M153.03 21.91l165.46 14.17v1.01L150.21 22.68v-.77h2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-187",
    fill: "#ff7749",
    d: "M164.88 21.91l153.61 13.15v1.02L153.03 21.91h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-188",
    fill: "#ff7849",
    d: "M176.72 21.91l141.77 12.14v1.01L164.88 21.91h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-189",
    fill: "#ff7949",
    d: "M188.57 21.91l129.92 11.13v1.01L176.72 21.91h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-190",
    fill: "#ff7a4a",
    d: "M200.41 21.91l118.08 10.11v1.02L188.57 21.91h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-191",
    fill: "#ff7b4a",
    d: "M212.26 21.91l106.23 9.1v1.01L200.41 21.91h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-192",
    fill: "#ff7c4b",
    d: "M224.1 21.91l94.39 8.08v1.02l-106.23-9.1h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-193",
    fill: "#ff7d4b",
    d: "M235.95 21.91l82.54 7.07v1.01l-94.39-8.08h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-194",
    fill: "#ff7e4b",
    d: "M247.79 21.91l70.7 6.06v1.01l-82.54-7.07h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-195",
    fill: "#ff7f4c",
    d: "M259.64 21.91l58.85 5.04v1.02l-70.7-6.06h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-196",
    fill: "#ff804c",
    d: "M271.48 21.91l47.01 4.03v1.01l-58.85-5.04h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-197",
    fill: "#ff804d",
    d: "M283.33 21.91l35.16 3.01v1.02l-47.01-4.03h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-198",
    fill: "#ff814d",
    d: "M295.17 21.91l23.32 2v1.01l-35.16-3.01h11.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-199",
    fill: "#ff824e",
    d: "M307.02 21.91l11.47.98v1.02l-23.32-2h11.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-200",
    fill: "#ff834e",
    d: "M318.49 22.89l-11.47-.98h11.47v.98z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "youtube-icon_svg__cls-4",
    style: {
      mixBlendMode: "multiply"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "youtube-icon_svg__cls-201",
    clipPath: "url(#youtube-icon_svg__b)",
    transform: "translate(175.595 103.197)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-202",
    fill: "#692237",
    d: "M151.47 163.36l65.65 27.32h-65.65v-27.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-202",
    fill: "#692237",
    d: "M151.47 162.62l67.43 28.06h-1.78l-65.65-27.32v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-203",
    fill: "#6a2237",
    d: "M151.47 161.88l69.21 28.8h-1.78l-67.43-28.06v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-204",
    fill: "#6b2237",
    d: "M151.47 161.14l70.99 29.54h-1.78l-69.21-28.8v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-205",
    fill: "#6c2237",
    d: "M151.47 160.4l72.77 30.28h-1.78l-70.99-29.54v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-206",
    fill: "#6d2237",
    d: "M151.47 159.66l74.55 31.02h-1.78l-72.77-30.28v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-207",
    fill: "#6e2236",
    d: "M151.47 158.91l76.32 31.77h-1.77l-74.55-31.02v-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-208",
    fill: "#6f2236",
    d: "M151.47 158.18l78.1 32.5h-1.78l-76.32-31.77v-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-209",
    fill: "#702236",
    d: "M151.47 157.44l79.88 33.24h-1.78l-78.1-32.5v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-210",
    fill: "#712236",
    d: "M151.47 156.69l81.66 33.99h-1.78l-79.88-33.24v-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-211",
    fill: "#722236",
    d: "M151.47 155.95l83.44 34.73h-1.78l-81.66-33.99v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-212",
    fill: "#732236",
    d: "M151.47 155.21l85.22 35.47h-1.78l-83.44-34.73v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-213",
    fill: "#742236",
    d: "M151.47 154.47l86.99 36.21h-1.77l-85.22-35.47v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-214",
    fill: "#752236",
    d: "M151.47 153.73l88.77 36.95h-1.78l-86.99-36.21v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-215",
    fill: "#762336",
    d: "M151.47 152.99l90.55 37.69h-1.78l-88.77-36.95v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-216",
    fill: "#772336",
    d: "M151.47 152.25l92.33 38.43h-1.78l-90.55-37.69v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-217",
    fill: "#782335",
    d: "M151.47 151.51l94.11 39.17h-1.78l-92.33-38.43v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-218",
    fill: "#792335",
    d: "M151.47 150.77l95.88 39.91h-1.77l-94.11-39.17v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-219",
    fill: "#7a2335",
    d: "M151.47 150.03l97.66 40.65h-1.78l-95.88-39.91v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-220",
    fill: "#7b2335",
    d: "M151.47 149.29l99.44 41.39h-1.78l-97.66-40.65v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-221",
    fill: "#7c2335",
    d: "M151.47 148.55l101.22 42.13h-1.78l-99.44-41.39v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-222",
    fill: "#7d2335",
    d: "M151.47 147.81l103 42.87h-1.78l-101.22-42.13v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-223",
    fill: "#7e2335",
    d: "M151.47 147.07l104.78 43.61h-1.78l-103-42.87v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-224",
    fill: "#7f2335",
    d: "M151.47 146.33l106.55 44.35h-1.77l-104.78-43.61v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-225",
    fill: "#802335",
    d: "M151.47 145.59l108.33 45.09h-1.78l-106.55-44.35v-.74zM151.47 144.85l110.11 45.83h-1.78l-108.33-45.09v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-226",
    fill: "#812334",
    d: "M151.47 144.11l111.89 46.57h-1.78l-110.11-45.83v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-227",
    fill: "#822334",
    d: "M151.47 143.37l113.67 47.31h-1.78l-111.89-46.57v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-228",
    fill: "#832334",
    d: "M151.47 142.63l115.45 48.05h-1.78l-113.67-47.31v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-229",
    fill: "#842334",
    d: "M151.47 141.89l117.22 48.79h-1.77l-115.45-48.05v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-230",
    fill: "#852334",
    d: "M151.47 141.15l119 49.53h-1.78l-117.22-48.79v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-231",
    fill: "#862334",
    d: "M151.47 140.41l120.78 50.27h-1.78l-119-49.53v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-232",
    fill: "#872334",
    d: "M151.47 139.67l122.56 51.01h-1.78l-120.78-50.27v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-233",
    fill: "#882334",
    d: "M151.47 138.93l124.34 51.75h-1.78l-122.56-51.01v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-234",
    fill: "#892334",
    d: "M151.47 138.19l126.12 52.49h-1.78l-124.34-51.75v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-235",
    fill: "#8a2334",
    d: "M151.47 137.45l127.9 53.23h-1.78l-126.12-52.49v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-236",
    fill: "#8b2333",
    d: "M151.47 136.71l129.67 53.97h-1.77l-127.9-53.23v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-237",
    fill: "#8c2333",
    d: "M151.47 135.97l131.45 54.71h-1.78l-129.67-53.97v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-238",
    fill: "#8d2333",
    d: "M151.47 135.23l133.23 55.45h-1.78l-131.45-54.71v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-239",
    fill: "#8e2433",
    d: "M151.47 134.49l135.01 56.19h-1.78l-133.23-55.45v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-240",
    fill: "#8f2433",
    d: "M151.47 133.75l136.79 56.93h-1.78l-135.01-56.19v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-241",
    fill: "#902433",
    d: "M151.47 133.01l138.57 57.67h-1.78l-136.79-56.93v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-242",
    fill: "#912433",
    d: "M151.47 132.27l140.34 58.41h-1.77l-138.57-57.67v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-243",
    fill: "#922433",
    d: "M151.47 131.53l142.12 59.15h-1.78l-140.34-58.41v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-244",
    fill: "#932433",
    d: "M151.47 130.79l143.9 59.89h-1.78l-142.12-59.15v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-245",
    fill: "#942433",
    d: "M151.47 130.05l145.68 60.63h-1.78l-143.9-59.89v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-246",
    fill: "#952432",
    d: "M151.47 129.31l147.46 61.37h-1.78l-145.68-60.63v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-6",
    fill: "#962432",
    d: "M151.47 128.57l149.23 62.11h-1.77l-147.46-61.37v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-7",
    fill: "#972432",
    d: "M151.47 127.83l151.01 62.85h-1.78l-149.23-62.11v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-8",
    fill: "#982432",
    d: "M151.47 127.09l152.79 63.59h-1.78l-151.01-62.85v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-9",
    fill: "#992432",
    d: "M151.47 126.35l153.45 63.87-.19.46h-.47l-152.79-63.59v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-10",
    fill: "#9a2432",
    d: "M151.47 125.61l153.71 63.98-.26.63-153.45-63.87v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-11",
    fill: "#9b2432",
    d: "M151.47 124.87l153.97 64.08-.26.64-153.71-63.98v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-12",
    fill: "#9c2432",
    d: "M151.47 124.13l154.24 64.19-.27.63-153.97-64.08v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-13",
    fill: "#9d2432",
    d: "M151.47 123.39l154.5 64.3-.26.63-154.24-64.19v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-14",
    fill: "#9e2432",
    d: "M151.47 122.65l154.76 64.41-.26.63-154.5-64.3v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-15",
    fill: "#9f2431",
    d: "M151.47 121.91l155.03 64.52-.27.63-154.76-64.41v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-16",
    fill: "#a02431",
    d: "M151.47 121.17l155.29 64.63-.26.63-155.03-64.52v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-17",
    fill: "#a12431",
    d: "M151.47 120.43l155.55 64.74-.26.63-155.29-64.63v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-18",
    fill: "#a22431",
    d: "M151.47 119.69l155.81 64.85-.26.63-155.55-64.74v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-19",
    fill: "#a32431",
    d: "M151.47 118.95l156.08 64.96-.27.63-155.81-64.85v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-20",
    fill: "#a42431",
    d: "M151.47 118.21l156.34 65.07-.26.63-156.08-64.96v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-21",
    fill: "#a52431",
    d: "M151.47 117.47l156.6 65.18-.26.63-156.34-65.07v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-22",
    fill: "#a62431",
    d: "M151.47 116.72l156.86 65.29-.26.64-156.6-65.18v-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-23",
    fill: "#a72531",
    d: "M151.47 115.98l157.13 65.4-.27.63-156.86-65.29v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-24",
    fill: "#a82531",
    d: "M151.47 115.25l157.39 65.5-.26.63-157.13-65.4v-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-25",
    fill: "#a92530",
    d: "M151.47 114.5l157.65 65.62-.26.63-157.39-65.5v-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-26",
    fill: "#aa2530",
    d: "M151.47 113.77l157.91 65.72-.26.63-157.65-65.62v-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-27",
    fill: "#ab2530",
    d: "M151.47 113.02l158.18 65.84-.27.63-157.91-65.72v-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-28",
    fill: "#ac2530",
    d: "M151.47 112.28l158.44 65.95-.26.63-158.18-65.84v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-29",
    fill: "#ad2530",
    d: "M151.47 111.54l158.7 66.06-.26.63-158.44-65.95v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-30",
    fill: "#ae2530",
    d: "M151.47 110.8l158.96 66.17-.26.63-158.7-66.06v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-31",
    fill: "#af2530",
    d: "M151.47 110.06l159.23 66.28-.27.63-158.96-66.17v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-32",
    fill: "#b02530",
    d: "M151.47 109.32l159.49 66.39-.26.63-159.23-66.28v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-33",
    fill: "#b12530",
    d: "M151.47 108.58l159.75 66.49-.26.64-159.49-66.39v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-34",
    fill: "#b22530",
    d: "M151.47 107.84l160.01 66.6-.26.63-159.75-66.49v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-35",
    fill: "#b4252f",
    d: "M151.47 107.1l160.28 66.71-.27.63-160.01-66.6v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-36",
    fill: "#b5252f",
    d: "M151.47 106.36l160.54 66.82-.26.63-160.28-66.71v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-37",
    fill: "#b6252f",
    d: "M151.47 105.62l160.8 66.93-.26.63-160.54-66.82v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-38",
    fill: "#b7252f",
    d: "M151.47 104.88l161.07 67.04-.27.63-160.8-66.93v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-39",
    fill: "#b8252f",
    d: "M151.47 104.14l161.33 67.15-.26.63-161.07-67.04v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-40",
    fill: "#b9252f",
    d: "M151.47 103.4l161.59 67.26-.26.63-161.33-67.15v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-41",
    fill: "#ba252f",
    d: "M151.47 102.66l161.85 67.37-.26.63-161.59-67.26v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-42",
    fill: "#bb252f",
    d: "M151.47 101.92l162.11 67.48-.26.63-161.85-67.37v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-43",
    fill: "#bc252f",
    d: "M151.47 101.18l162.38 67.59-.27.63-162.11-67.48v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-44",
    fill: "#bd252f",
    d: "M151.47 100.44l162.64 67.69-.26.64-162.38-67.59v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-45",
    fill: "#be252e",
    d: "M151.47 99.7l162.9 67.8-.26.63-162.64-67.69v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-46",
    fill: "#bf252e",
    d: "M151.47 98.96l163.16 67.91-.26.63-162.9-67.8v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-47",
    fill: "#c0262e",
    d: "M151.47 98.22l163.43 68.02-.27.63-163.16-67.91v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-48",
    fill: "#c1262e",
    d: "M151.47 97.48l163.69 68.13-.26.63-163.43-68.02v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-49",
    fill: "#c2262e",
    d: "M151.47 96.74l163.95 68.24-.26.63-163.69-68.13v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-50",
    fill: "#c3262e",
    d: "M151.47 96l164.22 68.35-.27.63-163.95-68.24V96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-51",
    fill: "#c4262e",
    d: "M151.47 95.26l164.48 68.46-.26.63L151.47 96v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-52",
    fill: "#c5262e",
    d: "M151.47 94.52l164.74 68.57-.26.63-164.48-68.46v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-53",
    fill: "#c6262e",
    d: "M151.47 93.78l165 68.68-.26.63-164.74-68.57v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-54",
    fill: "#c7262e",
    d: "M151.47 93.04l165.27 68.79-.27.63-165-68.68v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-55",
    fill: "#c8262d",
    d: "M151.47 92.3L317 161.19l-.26.64-165.27-68.79v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-56",
    fill: "#c9262d",
    d: "M151.47 91.56l165.79 69-.26.63L151.47 92.3v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-57",
    fill: "#ca262d",
    d: "M151.47 90.82l166.05 69.11-.26.63-165.79-69v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-58",
    fill: "#cb262d",
    d: "M151.47 90.08l166.32 69.22-.27.63-166.05-69.11v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-59",
    fill: "#cc262d",
    d: "M151.47 89.34l166.58 69.33-.26.63-166.32-69.22v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-60",
    fill: "#cd262d",
    d: "M151.47 88.6l166.84 69.44-.26.63-166.58-69.33v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-61",
    fill: "#ce262d",
    d: "M151.47 87.86l167.1 69.55-.26.63L151.47 88.6v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-62",
    fill: "#cf262d",
    d: "M151.47 87.12l167.37 69.66-.27.63-167.1-69.55v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-63",
    fill: "#d0262d",
    d: "M151.47 86.38l167.63 69.77-.26.63-167.37-69.66v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-64",
    fill: "#d1262d",
    d: "M151.47 85.64l167.89 69.88-.26.63-167.63-69.77v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-65",
    fill: "#d2262c",
    d: "M151.47 84.9l168.15 69.99-.26.63-167.89-69.88v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-66",
    fill: "#d3262c",
    d: "M151.47 84.16l168.42 70.09-.27.64L151.47 84.9v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-67",
    fill: "#d4262c",
    d: "M151.47 83.42l168.68 70.2-.26.63-168.42-70.09v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-68",
    fill: "#d5262c",
    d: "M151.47 82.68l168.94 70.31-.26.63-168.68-70.2v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-69",
    fill: "#d6262c",
    d: "M151.47 81.94l169.21 70.42-.27.63-168.94-70.31v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-70",
    fill: "#d7262c",
    d: "M151.47 81.2l169.47 70.53-.26.63-169.21-70.42v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-71",
    fill: "#d8262c",
    d: "M151.47 80.46L321.2 151.1l-.26.63L151.47 81.2v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-72",
    fill: "#d9272c",
    d: "M151.47 79.72l169.99 70.75-.26.63-169.73-70.64v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-73",
    fill: "#da272c",
    d: "M151.47 78.98l170.26 70.86-.27.63-169.99-70.75v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-74",
    fill: "#db272c",
    d: "M151.47 78.24l170.52 70.97-.26.63-170.26-70.86v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-75",
    fill: "#dc272b",
    d: "M151.47 77.5l170.78 71.08-.26.63-170.52-70.97v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-76",
    fill: "#dd272b",
    d: "M151.47 76.76l171.04 71.19-.26.63L151.47 77.5v-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-77",
    fill: "#de272b",
    d: "M151.47 76.58l.2-.48 171.1 71.22-.26.63-171.04-71.19v-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-78",
    fill: "#df272b",
    d: "M151.667 76.109l.26-.628 171.112 71.192-.261.627z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-79",
    fill: "#e0272b",
    d: "M151.94 75.47l.26-.63 171.07 71.2v.09l-.23.56-171.1-71.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-80",
    fill: "#e1272b",
    d: "M152.2 74.84l.26-.63 170.81 71.09v.74L152.2 74.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-81",
    fill: "#e2272b",
    d: "M152.46 74.21l.26-.63 170.55 70.98v.74L152.46 74.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-82",
    fill: "#e3272b",
    d: "M152.72 73.58l.27-.64 170.28 70.88v.74L152.72 73.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-83",
    fill: "#e4272b",
    d: "M152.99 72.94l.26-.63 170.02 70.77v.74L152.99 72.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-84",
    fill: "#e5272b",
    d: "M153.25 72.31l.26-.63 169.76 70.66v.74L153.25 72.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-85",
    fill: "#e6272a",
    d: "M153.51 71.68l.26-.63 169.5 70.55v.74L153.51 71.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-86",
    fill: "#e7272a",
    d: "M153.77 71.05l.27-.63 169.23 70.44v.74l-169.5-70.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-87",
    fill: "#e8272a",
    d: "M154.04 70.42l.26-.63 168.97 70.33v.74L154.04 70.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-88",
    fill: "#e9272a",
    d: "M154.3 69.79l.26-.63 168.71 70.22v.74L154.3 69.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-89",
    fill: "#ea272a",
    d: "M154.56 69.16l.26-.63 168.45 70.11v.74L154.56 69.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-90",
    fill: "#eb272a",
    d: "M154.82 68.53l.27-.63 168.18 70v.74L154.82 68.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-91",
    fill: "#ec272a",
    d: "M155.09 67.9l.26-.63 167.92 69.89v.74l-168.18-70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-92",
    fill: "#ed272a",
    d: "M155.35 67.27l.26-.63 167.66 69.78v.74L155.35 67.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-93",
    fill: "#ee272a",
    d: "M155.61 66.64l.27-.64 167.39 69.68v.74L155.61 66.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-94",
    fill: "#ef272a",
    d: "M155.88 66l.26-.63 167.13 69.57v.74L155.88 66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-95",
    fill: "#f02729",
    d: "M156.14 65.37l.26-.63 166.87 69.46v.74L156.14 65.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-96",
    fill: "#f12729",
    d: "M156.4 64.74l.26-.63 166.61 69.35v.74L156.4 64.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-97",
    fill: "#f22829",
    d: "M156.66 64.11l.27-.63 166.34 69.24v.74L156.66 64.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-98",
    fill: "#f32829",
    d: "M156.93 63.48l.26-.63 166.08 69.13v.74L156.93 63.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-99",
    fill: "#f42829",
    d: "M157.19 62.85l.26-.63 165.82 69.02v.74L157.19 62.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-100",
    fill: "#f52829",
    d: "M157.45 62.22l.26-.63 165.56 68.91v.74L157.45 62.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-101",
    fill: "#f62829",
    d: "M157.71 61.59l.27-.63 165.29 68.8v.74L157.71 61.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-102",
    fill: "#f72829",
    d: "M157.98 60.96l.26-.63 165.03 68.69v.74l-165.29-68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-103",
    fill: "#f82829",
    d: "M158.24 60.33l.26-.63 164.77 68.58v.74L158.24 60.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-104",
    fill: "#f92829",
    d: "M158.5 59.7l.26-.64 164.51 68.48v.74L158.5 59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-105",
    fill: "#fa2828",
    d: "M158.76 59.06l.27-.62 164.24 68.36v.74L158.76 59.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-106",
    fill: "#fb2828",
    d: "M159.03 58.44l.26-.64 163.98 68.26v.74L159.03 58.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-107",
    fill: "#fc2828",
    d: "M159.29 57.8l.26-.63 163.72 68.15v.74L159.29 57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-108",
    fill: "#fd2828",
    d: "M159.55 57.17l.26-.63 163.46 68.04v.74L159.55 57.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-109",
    fill: "#ff2828",
    d: "M159.81 56.54l.27-.63 163.19 67.93v.74L159.81 56.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-109",
    fill: "#ff2828",
    d: "M160.08 55.91l.29-.7 162.9 67.8v.83L160.08 55.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-110",
    fill: "#ff2928",
    d: "M160.37 55.21l.29-.71 162.61 67.68v.83l-162.9-67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-111",
    fill: "#ff2a29",
    d: "M160.66 54.5l.3-.7 162.31 67.55v.83L160.66 54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-112",
    fill: "#ff2b29",
    d: "M160.96 53.8l.29-.71 162.02 67.44v.82L160.96 53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-113",
    fill: "#ff2c2a",
    d: "M161.25 53.09l.29-.71 161.73 67.32v.83L161.25 53.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-114",
    fill: "#ff2d2a",
    d: "M161.54 52.38l.3-.7 161.43 67.19v.83L161.54 52.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-115",
    fill: "#ff2e2b",
    d: "M161.84 51.68l.29-.71 161.14 67.07v.83L161.84 51.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-116",
    fill: "#ff2f2b",
    d: "M162.13 50.97l.3-.7 160.84 66.95v.82L162.13 50.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-117",
    fill: "#ff302b",
    d: "M162.43 50.27l.29-.71 160.55 66.83v.83L162.43 50.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-118",
    fill: "#ff312c",
    d: "M162.72 49.56l.29-.7 160.26 66.7v.83L162.72 49.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-119",
    fill: "#ff322c",
    d: "M163.01 48.86l.3-.71 159.96 66.58v.83l-160.26-66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-120",
    fill: "#ff332d",
    d: "M163.31 48.15l.29-.7 159.67 66.46v.82L163.31 48.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-121",
    fill: "#ff342d",
    d: "M163.6 47.45l.29-.71 159.38 66.34v.83L163.6 47.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-122",
    fill: "#ff352d",
    d: "M163.89 46.74l.3-.7 159.08 66.21v.83L163.89 46.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-123",
    fill: "#ff362e",
    d: "M164.19 46.04l.29-.71 158.79 66.09v.83L164.19 46.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-124",
    fill: "#ff372e",
    d: "M164.48 45.33l.29-.7 158.5 65.97v.82L164.48 45.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-125",
    fill: "#ff382f",
    d: "M164.77 44.63l.3-.71 158.2 65.85v.83l-158.5-65.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-126",
    fill: "#ff392f",
    d: "M165.07 43.92l.29-.7 157.91 65.72v.83l-158.2-65.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-127",
    fill: "#ff3a30",
    d: "M165.36 43.22l.29-.71 157.62 65.6v.83L165.36 43.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-128",
    fill: "#ff3b30",
    d: "M165.65 42.51l.3-.71 157.32 65.49v.82l-157.62-65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-129",
    fill: "#ff3c30",
    d: "M165.95 41.8l.29-.7 157.03 65.36v.83L165.95 41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-130",
    fill: "#ff3d31",
    d: "M166.24 41.1l.29-.71 156.74 65.24v.83L166.24 41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-131",
    fill: "#ff3e31",
    d: "M166.53 40.39l.3-.7 156.44 65.11v.83L166.53 40.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-132",
    fill: "#ff3f32",
    d: "M166.83 39.69l.29-.71 156.15 65v.82L166.83 39.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-133",
    fill: "#ff4032",
    d: "M167.12 38.98l.3-.7 155.85 64.87v.83l-156.15-65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-134",
    fill: "#ff4132",
    d: "M167.42 38.28l.29-.71 155.56 64.75v.83L167.42 38.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-135",
    fill: "#ff4233",
    d: "M167.71 37.57l.29-.7 155.27 64.62v.83L167.71 37.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-136",
    fill: "#ff4333",
    d: "M168 36.87l.3-.71 154.97 64.51v.82L168 36.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-137",
    fill: "#ff4434",
    d: "M168.3 36.16l.29-.7 154.68 64.38v.83L168.3 36.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-138",
    fill: "#ff4534",
    d: "M168.59 35.46l.29-.71 154.39 64.26v.83L168.59 35.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-139",
    fill: "#ff4635",
    d: "M168.88 34.75l.3-.7 154.09 64.13v.83L168.88 34.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-140",
    fill: "#ff4735",
    d: "M169.18 34.05l.29-.71 153.8 64.02v.82L169.18 34.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-141",
    fill: "#ff4835",
    d: "M169.47 33.34l.29-.71 153.51 63.9v.83l-153.8-64.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-142",
    fill: "#ff4936",
    d: "M169.76 32.63l.3-.7L323.27 95.7v.83l-153.51-63.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-143",
    fill: "#ff4a36",
    d: "M170.06 31.93l.29-.7 152.92 63.64v.83L170.06 31.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-144",
    fill: "#ff4b37",
    d: "M170.35 31.23l.3-.71 152.62 63.53v.82L170.35 31.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-145",
    fill: "#ff4c37",
    d: "M170.65 30.52l.29-.71 152.33 63.41v.83L170.65 30.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-146",
    fill: "#ff4d37",
    d: "M170.94 29.81l.29-.7 152.04 63.28v.83L170.94 29.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-147",
    fill: "#ff4e38",
    d: "M171.23 29.11l.3-.71 151.74 63.16v.83L171.23 29.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-148",
    fill: "#ff4f38",
    d: "M171.53 28.4l.29-.7 151.45 63.03v.83L171.53 28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-149",
    fill: "#ff5039",
    d: "M171.82 27.7l.29-.71 151.16 62.92v.82L171.82 27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-150",
    fill: "#ff5139",
    d: "M172.11 26.99l.3-.7 150.86 62.79v.83L172.11 26.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-151",
    fill: "#ff523a",
    d: "M172.41 26.29l.29-.71 150.57 62.67v.83L172.41 26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-152",
    fill: "#ff533a",
    d: "M172.7 25.58l.29-.7 150.28 62.54v.83L172.7 25.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-153",
    fill: "#ff543a",
    d: "M172.99 24.88l.3-.71L323.27 86.6v.82L172.99 24.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-154",
    fill: "#ff553b",
    d: "M173.29 24.17l.29-.7 149.69 62.3v.83L173.29 24.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-155",
    fill: "#ff563b",
    d: "M173.58 23.47l.29-.71 149.4 62.18v.83l-149.69-62.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-156",
    fill: "#ff573c",
    d: "M173.87 22.76l.3-.7 149.1 62.05v.83l-149.4-62.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-157",
    fill: "#ff583c",
    d: "M174.17 22.06l.29-.71 148.81 61.94v.82l-149.1-62.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-158",
    fill: "#ff593c",
    d: "M174.46 21.35l.29-.71 148.52 61.82v.83L174.46 21.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-159",
    fill: "#ff5a3d",
    d: "M174.75 20.64l.3-.7 148.22 61.69v.83L174.75 20.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-160",
    fill: "#ff5b3d",
    d: "M175.05 19.94l.29-.71 147.93 61.58v.82L175.05 19.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-161",
    fill: "#ff5c3e",
    d: "M175.34 19.23l.3-.7 147.63 61.45v.83L175.34 19.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-162",
    fill: "#ff5d3e",
    d: "M175.64 18.53l.29-.71 147.34 61.33v.83L175.64 18.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-163",
    fill: "#ff5e3f",
    d: "M175.93 17.82l.29-.7 147.05 61.2v.83L175.93 17.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-164",
    fill: "#ff5f3f",
    d: "M176.22 17.12l.3-.71L323.27 77.5v.82l-147.05-61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-165",
    fill: "#ff603f",
    d: "M176.52 16.41l.29-.7 146.46 60.96v.83L176.52 16.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-166",
    fill: "#ff6140",
    d: "M176.81 15.71l.29-.71 146.17 60.84v.83L176.81 15.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-167",
    fill: "#ff6340",
    d: "M177.1 15l.3-.7 145.87 60.71v.83L177.1 15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-168",
    fill: "#ff6441",
    d: "M177.4 14.3l.29-.71 145.58 60.6v.82L177.4 14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-169",
    fill: "#ff6541",
    d: "M177.69 13.59l.29-.7 145.29 60.47v.83l-145.58-60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-170",
    fill: "#ff6641",
    d: "M177.98 12.89l.3-.71 144.99 60.35v.83L177.98 12.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-171",
    fill: "#ff6742",
    d: "M178.28 12.18l.29-.7 144.7 60.22v.83L178.28 12.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-172",
    fill: "#ff6842",
    d: "M178.57 11.48l.3-.71 144.4 60.11v.82l-144.7-60.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-173",
    fill: "#ff6943",
    d: "M178.87 10.77l.29-.71 144.11 59.99v.83l-144.4-60.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-174",
    fill: "#ff6a43",
    d: "M179.16 10.06l.29-.7 143.82 59.86v.83L179.16 10.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-175",
    fill: "#ff6b44",
    d: "M179.45 9.36l.3-.71 143.52 59.74v.83L179.45 9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-176",
    fill: "#ff6c44",
    d: "M179.75 8.65l.29-.7 143.23 59.61v.83L179.75 8.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-177",
    fill: "#ff6d44",
    d: "M180.04 7.95l.29-.71 142.94 59.5v.82L180.04 7.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-178",
    fill: "#ff6e45",
    d: "M180.33 7.24l.3-.7 142.64 59.37v.83L180.33 7.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-179",
    fill: "#ff6f45",
    d: "M180.63 6.54l.29-.71 142.35 59.25v.83L180.63 6.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-180",
    fill: "#ff7046",
    d: "M180.92 5.83l.29-.7 142.06 59.12v.83L180.92 5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-181",
    fill: "#ff7146",
    d: "M181.21 5.13l.3-.71 141.76 59.01v.82L181.21 5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-182",
    fill: "#ff7246",
    d: "M181.51 4.42l.29-.7L323.27 62.6v.83L181.51 4.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-183",
    fill: "#ff7347",
    d: "M181.8 3.72l.1-.25h1.3l140.07 58.3v.83L181.8 3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-184",
    fill: "#ff7447",
    d: "M185.19 3.47l138.08 57.48v.82L183.2 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-185",
    fill: "#ff7548",
    d: "M187.17 3.47l136.1 56.65v.83L185.19 3.47h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-186",
    fill: "#ff7648",
    d: "M189.16 3.47l134.11 55.82v.83L187.17 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-187",
    fill: "#ff7749",
    d: "M191.15 3.47l132.12 54.99v.83L189.16 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-188",
    fill: "#ff7849",
    d: "M193.14 3.47l130.13 54.16v.83L191.15 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-189",
    fill: "#ff7949",
    d: "M195.13 3.47l128.14 53.34v.82L193.14 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-190",
    fill: "#ff7a4a",
    d: "M197.11 3.47l126.16 52.51v.83L195.13 3.47h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-191",
    fill: "#ff7b4a",
    d: "M199.1 3.47l124.17 51.68v.83L197.11 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-192",
    fill: "#ff7c4b",
    d: "M201.09 3.47l122.18 50.86v.82L199.1 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-193",
    fill: "#ff7d4b",
    d: "M203.08 3.47L323.27 53.5v.83L201.09 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-194",
    fill: "#ff7e4b",
    d: "M205.07 3.47l118.2 49.2v.83L203.08 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-195",
    fill: "#ff7f4c",
    d: "M207.05 3.47l116.22 48.37v.83l-118.2-49.2h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-196",
    fill: "#ff804c",
    d: "M209.04 3.47l114.23 47.55v.82L207.05 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-197",
    fill: "#ff804d",
    d: "M211.03 3.47l112.24 46.72v.83L209.04 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-198",
    fill: "#ff814d",
    d: "M213.02 3.47l110.25 45.89v.83L211.03 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-199",
    fill: "#ff824e",
    d: "M215.01 3.47l108.26 45.06v.83L213.02 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-200",
    fill: "#ff834e",
    d: "M217 3.47L323.27 47.7v.83L215.01 3.47H217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-247",
    fill: "#ff844e",
    d: "M218.98 3.47l104.29 43.41v.82L217 3.47h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-248",
    fill: "#ff854f",
    d: "M220.97 3.47l102.3 42.58v.83L218.98 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-249",
    fill: "#ff864f",
    d: "M222.96 3.47l100.31 41.75v.83L220.97 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-250",
    fill: "#ff8750",
    d: "M224.95 3.47l98.32 40.93v.82L222.96 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-251",
    fill: "#ff8850",
    d: "M226.94 3.47l96.33 40.1v.83L224.95 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-252",
    fill: "#ff8950",
    d: "M228.92 3.47l94.35 39.27v.83l-96.33-40.1h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-253",
    fill: "#ff8a51",
    d: "M230.91 3.47l92.36 38.44v.83L228.92 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-254",
    fill: "#ff8b51",
    d: "M232.9 3.47l90.37 37.62v.82L230.91 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-255",
    fill: "#ff8c52",
    d: "M234.89 3.47l88.38 36.79v.83L232.9 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-256",
    fill: "#ff8d52",
    d: "M236.88 3.47l86.39 35.96v.83L234.89 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-257",
    fill: "#ff8e53",
    d: "M238.87 3.47l84.4 35.13v.83L236.88 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-258",
    fill: "#ff8f53",
    d: "M240.85 3.47l82.42 34.3v.83l-84.4-35.13h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-259",
    fill: "#ff9053",
    d: "M242.84 3.47l80.43 33.48v.82l-82.42-34.3h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-260",
    fill: "#ff9154",
    d: "M244.83 3.47l78.44 32.65v.83L242.84 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-261",
    fill: "#ff9254",
    d: "M246.82 3.47l76.45 31.82v.83L244.83 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-262",
    fill: "#ff9355",
    d: "M248.81 3.47l74.46 31v.82L246.82 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-263",
    fill: "#ff9455",
    d: "M250.79 3.47l72.48 30.17v.83l-74.46-31h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-264",
    fill: "#ff9555",
    d: "M252.78 3.47l70.49 29.34v.83L250.79 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-265",
    fill: "#ff9656",
    d: "M254.77 3.47l68.5 28.51v.83L252.78 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-266",
    fill: "#ff9756",
    d: "M256.76 3.47l66.51 27.69v.82l-68.5-28.51h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-267",
    fill: "#ff9857",
    d: "M258.75 3.47l64.52 26.86v.83L256.76 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-268",
    fill: "#ff9957",
    d: "M260.73 3.47l62.54 26.03v.83L258.75 3.47h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-269",
    fill: "#ff9a58",
    d: "M262.72 3.47l60.55 25.2v.83L260.73 3.47h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-270",
    fill: "#ff9b58",
    d: "M264.71 3.47l58.56 24.37v.83l-60.55-25.2h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-270",
    fill: "#ff9b58",
    d: "M323.27 27.84L264.71 3.47h58.56v24.37z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-271",
    d: "M461.705 196.927s-.93-6.53-3.63-9.37c-3.43-3.72-7.31-3.77-9-4-12.65-.93-31.62-.93-31.62-.93h-.11s-18.92 0-31.57.93c-1.81.25-5.64.3-9.07 4-2.7 2.84-3.63 9.37-3.63 9.37a144.36 144.36 0 00-.93 15.19v7.21a142.18 142.18 0 00.93 15.2s.93 6.52 3.63 9.42c3.43 3.77 7.94 3.63 10 4 7.21.73 30.75 1 30.75 1s19-.1 31.62-1c1.71-.25 5.59-.25 9-4 2.7-2.9 3.63-9.42 3.63-9.42a150.14 150.14 0 00.88-15.2v-7.21c0-7.55-.88-15.19-.88-15.19zm-29.22 17.84l-24.47 13.19v-26.47l11.08 6z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "youtube-icon_svg__cls-272",
    d: "M394.465 123.607s5.89 11.38 20.23 5.77 16.08-27 0-26.15-25.83 12.91-20.23 20.38zM370.595 138.917s4.48 5.45 12.69-.94 1.5-16.14-7.3-12.36c-5.28 2.28-8.47 9.35-5.39 13.3z",
    fill: "#ff7a4a",
    fillRule: "evenodd"
  }))));
}

export default __webpack_public_path__ + "static/youtube-icon.f5ded014.svg";
export { SvgYoutubeIcon as ReactComponent };